import { Box, FormControl, TextField, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DropDown from "../common/Dropdown/Dropdown";
import { timeframeOptions } from "../../variables/constants";
import {
  updateDates,
  updateTimeframe,
} from "../../redux/features/reconcileSlice";
import "./styles.scss";
import CustomDateRange from "../common/Dialog/CustomDateRange";
import { RootState } from "../../redux/store";

const TableFilters = ({
  search,
  status,
  setStatus,
  onSearchChange,
}: {
  search: string;
  status: string;
  // eslint-disable-next-line no-unused-vars
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setStatus: Function;
  clearSearch: Function;
}) => {
  const { timeframe } = useSelector(
    (state: RootState) => state.transactionDetailsState
  );
  const [timeFrame, setTimeFrame] = useState(timeframe ?? "");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateTimeframe(timeFrame));
    timeFrame === "2" && setOpen(true);
  }, [timeFrame]);

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleApplyClose = () => {
    setOpen(false);
    setTimeFrame("0");
    dispatch(updateTimeframe("0"));
  };

  return (
    <Box className="headding-row">
      <Typography variant="h5" component="h4">
        Account Activity
      </Typography>
      <Box className="filters">
        <DropDown
          val={status}
          setVal={setStatus}
          options={[
            { value: "All", label: "All" },
            { value: "Outstanding", label: "Outstanding" },
            { value: "Reconciled", label: "Reconciled" },
          ]}
          label="Status"
          width="240px"
        />
        <DropDown
          val={timeFrame}
          setVal={setTimeFrame}
          options={timeframeOptions}
          label="Time Frame"
          width="236px"
          height="36px"
        />
        <FormControl>
          <TextField
            size="small"
            variant="outlined"
            placeholder="Amount"
            value={search}
            type="number"
            onChange={onSearchChange}
          />
        </FormControl>
        <CustomDateRange
          handleClose={handleClose}
          open={open}
          handleApplyClose={handleApplyClose}
          updateDates={updateDates}
        />
      </Box>
    </Box>
  );
};

export default TableFilters;
